import React, { memo, useCallback } from 'react';
import { Line } from 'react-konva';

export const DrawingLine = memo(({ 
  id,
  points,
  stroke = '#000',
  strokeWidth = 2,
  isSelected,
  onSelect
}) => {
  // Memoized callback
  const handleSelect = useCallback(() => {
    if (onSelect) onSelect(id);
  }, [id, onSelect]);

  return (
    <Line
      points={points}
      stroke={isSelected ? '#3d9168' : stroke}
      strokeWidth={isSelected ? strokeWidth + 1 : strokeWidth}
      tension={0.5}
      lineCap="round"
      lineJoin="round"
      onClick={handleSelect}
      onTap={handleSelect}
    />
  );
});
